import { HStack, Text, Button, Spacer } from '@chakra-ui/react';
import React from 'react';
import { selectTabEnum } from './MaintenanceHeader';

interface props {
  selectTab: number;
}

export const MaintenanceOtherTitle: React.FC<props> = (props) => {
  const { selectTab } = props;
  const GetTitle = () => {
    switch (selectTab) {
      case selectTabEnum.TransitLogs:
        return '発着履歴';
      case selectTabEnum.Signages:
        return 'サイネージ';
      case selectTabEnum.Settings:
        return '初期設定';
    }
  };
  return (
    <>
      <HStack bgColor='#e5e6e7' h='20'>
        <Text ml={16} fontSize='32' color='#5e6469'>
          {GetTitle()}
        </Text>
        <Spacer />
        {selectTab === selectTabEnum.TransitLogs && (
          <Button mr={10}>CSVダウンロード</Button>
        )}
      </HStack>
    </>
  );
};
